import { AnyAction, Dispatch } from '@reduxjs/toolkit'
import { fetchAiSubscription } from 'store/slices/subscription/subscription'
import { assertProd } from 'utils/assert-prod'

/**
 * This utility syncs the Redux store with subscription data from the API.
 * To get it working on a page, call useLoadAiSubscription() hook immediately
 * inside of an authentication container.
 * @param dispatch
 * @param uid
 */
export const loadAiSubscription = async (dispatch: Dispatch<AnyAction>, uid?: string) => {
  assertProd(!!uid, 'uid is required. (loadAiSubscription)')

  if (!uid) return

  // Dispatch the action that will trigger
  // the saga to call the /api/subscriptions/status endpoint
  dispatch(fetchAiSubscription({ uid }))
}
